module.exports = __webpack_public_path__ + "img/Site_Elin_GROUPAMA.4aac1dbe.jpg";